module.exports = __webpack_public_path__ + "img/admin.76844643.svg";